import { render, staticRenderFns } from "./file-parse-submitted-files.vue?vue&type=template&id=665e094a&scoped=true&"
import script from "./file-parse-submitted-files.vue?vue&type=script&lang=ts&"
export * from "./file-parse-submitted-files.vue?vue&type=script&lang=ts&"
import style0 from "./file-parse-submitted-files.vue?vue&type=style&index=0&id=665e094a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e094a",
  null
  
)

export default component.exports